












































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import BestFitText from "@/components/BestFitText.vue";
import PaymentMethodManager from '@/components/payment/PaymentMethodManager.vue';
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue';
import { Permissions } from '@/models/PermissionEnum';
import Project from '@/models/Project.ts';
import ProjectServer from '@/models/ProjectServer';
import router from '@/router';
import Mutations from '@/store/mutations';
import { IsProjectHidden, HideProject, UnhideProject } from '@/util/LocalProjectHiding';

import DeleteManager from './DeleteModal.vue';
import InviteManager from './InviteModal.vue';
import ProjectEditor from './ProjectEditModal.vue';

export default Vue.extend(
{
	components: 
	{
		ProjectEditor,
		InviteManager,
		DeleteManager,
		BestFitText,
		SubscriptionPanel,
		PaymentMethodManager
	},
	mounted()
	{
		this.getTier();
	},
	data()
	{
		return {
			modalLoad: false,
			generation: 0,
			tier: <number | null>null,
			users: <{premium: boolean}[]|null>null,
			freeUserBudget: 0,
			userBudget_local: 0
		}
	},
	props: 
	{
		project : Project,
		refreshProjects : Function,
		showHiddenProjects : Boolean
	},
	computed: 
	{
		...mapGetters([
			'checkProjectAccess',
			'checkProjectTimelineForceWrite',
			'checkMetadataEdit',
			'checkInviteManage',
			'checkProjectDelete',
			'checkAdmin'
		]),
	},
	methods: 
	{
		async getTier()
		{
			this.tier = null;
			this.tier = await this.$store.dispatch('getProjectSubscription', this.project.pid);
			const t : number = (this.tier == null) ? 0 : <number><unknown>this.tier;

			switch (t)
			{
				case 0: this.userBudget_local = 0; break;
				case 1: this.userBudget_local = 20; break;
				case 2: this.userBudget_local = 50; break;
				case 3: this.userBudget_local = 100; break;
				case 4: this.userBudget_local = 250; break;
			}
		},
		showModal(name : string)
		{
			this.modalLoad = true
			setTimeout(() =>
			{
				(this.$refs[name] as any).show();
			}, 0);
		},
		copyProject()
		{
			this.$emit('copy-project', this.project);
		},
		unhideProject()
		{
			UnhideProject(this.project);
			this.$recompute('isProjectHidden')
			this.refreshProjects();
		},
		hideProject()
		{
			this.$bvToast.toast(this.project.name + ' is now hidden. Click "View Hidden Projects" to access or unhide it',
			{
				title: 'Project Hidden',
				variant: 'warning',
				autoHideDelay: 6000
			});

			HideProject(this.project);
			this.$recompute('isProjectHidden')
		},
		notImplemented()
		{
			alert('Not implemented');
		},
		clickEnter()
		{
			let inst = ProjectServer.instance;
			inst.IsRequestingAddress = true;
			router.push("/app/project/timelines");
			this.$http.post(`connect`, { projectId: this.project.id }).then(
				(result) =>
				{
					if (!ProjectServer.isActiveInstance(inst))
					{
						inst.disconnect();
						return;
					}
					
					if (result.data.error != undefined)
					{
						// if error, do nothing
						alert(result.data.error);
						inst.disconnect();
						this.$router.push("/");
						return;
					}
					else
					{
						// otherwise, connect
						this.$store.commit(Mutations.setProject, this.project);
						this.$store.dispatch('getProjectSubscription');

						ProjectServer.host = result.data.ip;
						ProjectServer.port = result.data.port;
						
						const troute = result.data.route;
						ProjectServer.route = troute == undefined ? null : troute;

						inst.connectToServer();
						console.log(Object.assign({}, this.project));
					}
					inst.IsRequestingAddress = false;
				},
				(error) =>
                {
					if (error.response.data.error)
					{
						alert(`Couldn't connect - ${error.response.data.error}`);
					}
					else
					{
						alert(`Couldn't connect - ${JSON.stringify(error.response.data)}`);
					}
					inst.disconnect();
					this.$router.push("/");
                }
			);
		}
	},
	recomputed: 
	{
		isProjectHidden()
		{
			return IsProjectHidden(this.project);
		}
	}
})
